import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { getBranchColor } from './BranchSelector';

const BranchComparison = ({ dashboardStats, selectedBranchId }) => {
  if (!dashboardStats?.comparison || selectedBranchId !== 'all') return null;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-8" data-testid="branch-comparison">
      {dashboardStats.comparison.map((b, index) => {
        const bColor = getBranchColor(b.branchId);
        return (
          <div key={b.branchId} className="card-premium rounded-2xl p-5 fade-up" style={{ animationDelay: `${index * 80}ms` }}>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <span className={`w-2 h-2 rounded-full pulse-dot ${bColor.dot}`} />
                <span className="font-display font-semibold text-base">{b.branchName}</span>
              </div>
              <ArrowUpRight size={14} className="text-muted-foreground" />
            </div>
            <div className="grid grid-cols-4 gap-3">
              {[
                ['Aktif',  b.active,       'hsl(var(--brand))'],
                ['Teslim', b.delivered,     '#10b981'],
                ['Takili', b.stageStuck,    '#eab308'],
                ['Hazir',  b.readyWaiting || 0, '#A8A8B3'],
              ].map(([label, value, color]) => (
                <div key={label}>
                  <div className="font-mono font-semibold text-xl" style={{ color }}>{value}</div>
                  <div className="text-[10px] uppercase tracking-wider text-muted-foreground mt-1">{label}</div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BranchComparison;
